// extracted by mini-css-extract-plugin
module.exports = {"el":"index-module--el--1nb1o","blue":"index-module--blue--l8CNz","contact":"index-module--contact--SfxSV"};